import { client } from '../http';

export default {
  async createSubscription({ subscriptionType, token }) {
    const response = await client.post('/api/cashflow-subscription', { subscriptionType, token });
    return response.data;
  },

  async updateSubscription({ subscriptionType, token }) {
    const response = await client.put('/api/cashflow-subscription', { subscriptionType, token });
    return response.data;
  },

  async cancel() {
    const response = await client.delete('/api/cashflow-subscription/cancel');
    return response.data;
  },

  async terminate() {
    const response = await client.delete('/api/cashflow-subscription/terminate');
    return response.data;
  },

  async sync() {
    const response = await client.post('/api/cashflow-subscription/sync', {});
    return response.data;
  },

  async purchaseNtd({ token }) {
    const response = await client.post('/api/cashflow-subscription/ntd', { token });
    return response.data;
  },
};
